/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_DownloadInputs */

const cs_documents_download = /** @type {(inputs: Documents_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout`)
};

const en_documents_download = /** @type {(inputs: Documents_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Documents_DownloadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_download = /** @type {((inputs?: Documents_DownloadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_DownloadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_download(inputs)
	return cs_documents_download(inputs)
});